import useOnRightClick from './useOnRightClick';

export default useOnRightClick;